import DocumentLibrary from "../components/DocumentLibrary";

export default function Bill() {
  return (
    <DocumentLibrary
      docType="bill"
      title="Bill"
      subtitle="OA-linked bills"
      accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
      columns={["OA Number", "Customer", "Bill Number", "Bill Date", "Bill Amount", "OA Net", "Match", "File Name", "File Type"]}
      metaFields={[
        { key: "oaNumber", label: "OA Number", required: true },
        { key: "customerName", label: "Customer" },
        { key: "billNumber", label: "Bill Number", required: true },
        { key: "billDate", label: "Bill Date", type: "date" },
        { key: "billAmount", label: "Bill Amount (₹)", type: "number" },
      ]}
    />
  );
}
